// src/v3/IconTag/index.tsx
import { cva as cva2 } from "class-variance-authority";

// src/v3/Typography/index.tsx
import { cva } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
var typography = cva("", {
  variants: {
    variant: {
      h1: "ui-text-[2.5rem] ui-tracking-tight md:ui-text-[3.75rem] lg:ui-text-[5rem]",
      h2: "ui-text-[2.25rem] ui-tracking-normal md:ui-text-[3rem] lg:ui-text-[4.25rem] lg:ui-tracking-[-2px]",
      h3: "ui-text-[2rem] ui-tracking-normal md:ui-text-[2.5rem] lg:ui-text-[3.5rem]",
      h4: "ui-text-[1.75rem] ui-tracking-normal md:ui-text-[2rem] lg:ui-text-[2.5rem]",
      h5: "ui-text-[1.25rem] ui-tracking-normal lg:ui-leading-10",
      h6: "ui-text-[1.25rem] ui-tracking-normal",
      "body-large": "ui-text-[1.125rem] ui-tracking-normal",
      "title-large": "ui-text-[4.25rem] md:ui-text-7xl lg:ui-text-8xl xl:ui-text-[7.5rem]",
      "title-small": "ui-text-[4.25rem] md:ui-text-7xl lg:ui-text-[5rem]",
      base: "ui-text-base ui-tracking-normal",
      "body-small": "ui-text-[0.875rem] ui-tracking-normal",
      "eyebrow-large": "ui-text-base",
      "eyebrow-small": "ui-text-[0.75rem]",
      unset: ""
    },
    align: {
      left: "ui-text-left",
      center: "ui-text-center",
      right: "ui-text-right",
      justify: "ui-text-justify",
      centerMdLeft: "ui-text-center md:ui-text-left",
      centerLgLeft: "ui-text-center lg:ui-text-left"
    },
    color: {
      light: "ui-text-sandstone-200",
      dark: "ui-text-sandstone-500",
      disabled: "ui-text-gray-300",
      error: "ui-text-red-600",
      gray: "ui-text-gray-400",
      success: "ui-text-green-600",
      inherit: "ui-text-inherit",
      unset: ""
    },
    font: {
      sans: "ui-font-sans",
      serif: "ui-font-serif",
      "serif-italic": "ui-font-serif ui-italic"
    },
    height: {
      none: "ui-leading-none",
      tight: "ui-leading-tight",
      snug: "ui-leading-snug",
      normal: "ui-leading-normal",
      relaxed: "ui-leading-relaxed",
      loose: "ui-leading-loose",
      heading: "ui-leading-heading"
    },
    weight: {
      thin: "ui-font-thin",
      extralight: "ui-font-extralight",
      light: "ui-font-light",
      normal: "ui-font-normal",
      medium: "ui-font-medium",
      semibold: "ui-font-semibold",
      bold: "ui-font-bold",
      extrabold: "ui-font-extrabold",
      black: "ui-font-black"
    }
  },
  defaultVariants: {
    variant: "base",
    height: "normal",
    weight: "normal",
    font: "sans"
  }
});
function Typography({
  align = "left",
  Element = "p",
  children,
  className,
  color = "dark",
  font = "sans",
  height,
  variant = "base",
  weight = "normal",
  style,
  ...props
}) {
  let _weight = weight;
  if (variant === "h1" || variant === "h2" || variant === "h3" || variant === "h4") {
    _weight = "light";
  }
  return /* @__PURE__ */ jsx(Element, {
    className: typography({
      align,
      color,
      height,
      variant,
      weight: _weight,
      font,
      className
    }),
    style,
    ...props,
    children
  });
}
Typography.displayName = "Typography";

// src/v3/IconTag/index.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var iconTagVar = cva2(
  "ui-rounded-full ui-text-center ui-inline-block ui-transition ui-items-center ui-gap-x-2 ui-inline-flex",
  {
    variants: {
      variant: {
        primary: "ui-bg-[#000000] ui-bg-opacity-40 ui-pointer-events-none ui-text-sandstone-200 ui-backdrop-blur-sm",
        "transparent-light": "ui-bg-white ui-bg-opacity-40 ui-pointer-events-none ui-text-sandstone-500 ui-backdrop-blur-sm"
      },
      size: {
        none: "ui-p-0",
        small: "ui-py-2 ui-px-4",
        medium: "ui-py-2 ui-px-4 lg:ui-py-3 lg:ui-px-6",
        large: " ui-py-4 ui-px-6"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "large"
    }
  }
);
function IconTag({
  iconTagText,
  className = "",
  icon,
  size,
  variant,
  ...props
}) {
  return /* @__PURE__ */ jsxs("div", {
    className: iconTagVar({
      size,
      variant,
      className
    }),
    ...props,
    "data-cy": "icon-tag-container",
    children: [
      icon,
      /* @__PURE__ */ jsx2(Typography, {
        color: "inherit",
        "data-cy": "icon-tag-text",
        variant: "base",
        weight: "medium",
        children: iconTagText
      })
    ]
  });
}
IconTag.displayName = "IconTag";
export {
  IconTag
};
//# sourceMappingURL=index.mjs.map